import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ActCellIconType } from '../models/act-cell-icon-type';

@Injectable({
  providedIn: 'root',
})
export class UiStateService {
  private lastDisplayedMetadataUriSubject = new BehaviorSubject<string | null>(
    null
  );
  lastMetadataUri$ = this.lastDisplayedMetadataUriSubject.asObservable();

  private selectedRowIdSubject = new BehaviorSubject<string | null>(null);
  selectedRowId$ = this.selectedRowIdSubject.asObservable();

  private activeIconSource = new BehaviorSubject<{
    cellId: string;
    type: ActCellIconType;
  } | null>(null);
  activeIcon$ = this.activeIconSource.asObservable();
  private menuClosedSource = new BehaviorSubject<void>(undefined);
  menuClosed$ = this.menuClosedSource.asObservable();

  private previousState: { cellId: string; type: ActCellIconType } | null =
    null;

  private scrollPositionSubject = new BehaviorSubject<number | null>(null);
  scrollPosition$ = this.scrollPositionSubject.asObservable();

  private selectedColumnIdSubject = new BehaviorSubject<string | null>(null);
  selectedColumnId$ = this.selectedColumnIdSubject.asObservable();

  //Get last metadata displayed

  setLastDisplayedMetadataUri(uri: string): void {
    this.lastDisplayedMetadataUriSubject.next(uri);
  }

  getLastDisplayedMetadataUri(): string | null {
    return this.lastDisplayedMetadataUriSubject.value;
  }

  clearLastDisplayedMetadataUri(): void {
    this.lastDisplayedMetadataUriSubject.next(null);
  }

  shouldDisplayMetadata(uri: string): boolean {
    return this.getLastDisplayedMetadataUri() !== uri;
  }

  //  rowId

  setSelectedRowId(rowId: string): void {
    this.selectedRowIdSubject.next(rowId);
  }
  getSelectedRowId(): string | null {
    return this.selectedRowIdSubject.value;
  }
  //  columnId

  setSelectedColumnId(columnId: string): void {
    this.selectedColumnIdSubject.next(columnId);
  }
  getSelectedColumnId(): string | null {
    return this.selectedColumnIdSubject.value;
  }
  // scroll position

  setScrollPosition(position: number): void {
    this.scrollPositionSubject.next(position);
  }

  getScrollPosition(): number | null {
    return this.scrollPositionSubject.value;
  }

  clearScrollPosition(): void {
    this.scrollPositionSubject.next(null);
  }

  // icon state (details, menu)

  setActiveIcon(cellId: string, type: ActCellIconType): void {
    const previous = this.activeIconSource.getValue();

    if (
      type === ActCellIconType.Menu &&
      previous?.type === ActCellIconType.Info
    ) {
      this.previousState = previous;
    }

    this.activeIconSource.next({ cellId, type });
  }

  clearActiveIcons(): void {
    this.previousState = null;
    this.activeIconSource.next(null);
  }

  clearMenuIconsOnly(): void {
    const current = this.activeIconSource.getValue();

    if (current?.type === ActCellIconType.Menu) {
      if (this.previousState) {
        this.activeIconSource.next(this.previousState);
        this.previousState = null;
      } else {
        this.activeIconSource.next(null);
      }
      this.menuClosedSource.next();
    }
  }

  getCurrentActiveIcon(): {
    cellId: string;
    type: ActCellIconType.Info | ActCellIconType.Menu;
  } | null {
    const current = this.activeIconSource.getValue();
    return current;
  }
}
